import { ComponentProps } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import type { Placement } from "react-bootstrap/esm/types";
import "./AppTooltip.scss";

interface AppTooltipProps {
  text: string;
  placement?: Placement;
  popperConfig?: ComponentProps<typeof OverlayTrigger>["popperConfig"];
  children: React.ReactElement;
}

export function AppTooltip({ text, placement = "top", popperConfig, children }: AppTooltipProps) {
  return (
    <OverlayTrigger
      placement={placement}
      popperConfig={popperConfig}
      overlay={(props) => (
        <Tooltip {...props} className="app-tooltip">
          {text}
        </Tooltip>
      )}
    >
      {children}
    </OverlayTrigger>
  );
}
